import React from 'react';
import './FeedbackTab.less';

export default function FeedbackTab(props) {
    return (
        <div>
            {props.children}
            <div
                id="Feedback"
                className={`Feedback Feedback--${props.tabPosition}`}
            >
                <div
                    aria-label={props.tabText}
                    aria-haspopup="true"
                    aria-expanded={props.isOpen}
                    aria-controls="react-feedback"
                    role="button"
                    tabIndex="0"
                    onClick={props.onClick}
                    onKeyPress={props.onPress}
                    className={props.feedbackTabClassList}
                >
                    {props.tabText}
                </div>
            </div>
        </div>
    );
}
